// Keyed by the STORED outlet id — the value held in the customer's
// `custom.preferred_outlet` metafield. Never change a key; some of them read
// like old outlet names, but they are opaque identifiers and are never shown.
// `name` is the DISPLAY label printed on the quotation letterhead — change that
// freely, and keep it in step with outlet_labels in snippets/outlet-directory.liquid.
const OUTLET_DATA = {
  'Big Bath (Kuala Lumpur)': {
    name: 'Big Bath (Kuala Lumpur)',
    addr1: 'No. 16, Jalan Metro Pudu, Fraser Business Park,',
    addr2: 'Off Jalan Yew, 55200 Kuala Lumpur.',
    tel: '+60192286912',
    email: 'kl@bigbath.com.my',
    reg: '202001009968(1366288-P)',
  },
  'Big Bath (Puchong)': {
    name: 'Big Bath (Puchong)',
    addr1: 'No. 12, Jalan Puteri 1/2, Bandar Puteri,',
    addr2: '47100 Puchong, Selangor.',
    tel: '+60132899720',
    email: 'puchong@bigbath.com.my',
    reg: '201001038971(922895-P)',
  },
  'Big Bath (PJ, SS2)': {
    name: 'Big Bath (PJ, SS2)',
    addr1: 'No. 94, Jalan SS 2/24, SS2,',
    addr2: '47300 Petaling Jaya, Selangor.',
    tel: '+60193398366',
    email: 'pj@bigbath.com.my',
    reg: '202001030839(1387159-T)',
  },
  'Big Bath (Balakong)': {
    name: 'Big Bath (Balakong)',
    addr1: 'No. 9-G, Jalan C180/1, Dataran C180, Cheras,',
    addr2: '43200 Selangor.',
    tel: '+60196619721',
    email: 'balakong@bigbath.com.my',
    reg: '201001038971(922895-P)',
  },
  'Big Bath (Ipoh)': {
    name: 'Big Bath (Ipoh)',
    addr1: 'No. 1, Medan Ipoh 1A, Medan Ipoh Bistari,',
    addr2: '31400 Ipoh, Perak.',
    tel: '+60196619731',
    email: 'ipoh@bigbath.com.my',
    reg: '201001038971(922895-P)',
  },
  'Big Bath (Butterworth, Penang)': {
    name: 'Big Bath (Butterworth, Penang)',
    addr1: '7347, Jalan Kampung Baru, Taman Teratai Indah,',
    addr2: '13400 Butterworth, Pulau Pinang.',
    tel: '+60126631265',
    email: 'penang@bigbath.com.my',
    reg: '202001040417(1396738K)',
  },
  'Big Bath (Johor Bahru)': {
    name: 'Big Bath (Johor Bahru)',
    addr1: '85, Jalan Mutiara Emas 2A, Taman Mount Austin,',
    addr2: '81100 Johor Bahru.',
    tel: '+60196619730',
    email: 'johor@bigbath.com.my',
    reg: '201001038971(922895-P)',
  },
  'Big Bath (Kota Kinabalu, Sabah)': {
    name: 'Big Bath (Kota Kinabalu, Sabah)',
    addr1: '23B, Sedco Kolombong Industrial Estate, Jalan Kilang,',
    addr2: '88450 Kota Kinabalu, Sabah.',
    tel: '+60123106399',
    email: 'sabah@bigbath.com.my',
    reg: '201501036851(1162172-M)',
  },
  'Big Bath (Kuching, Sarawak)': {
    name: 'Big Bath (Kuching, Sarawak)',
    addr1: 'Block 2, Lot 1629, Section 64, Lorong Sebor,',
    addr2: 'Off Jalan Kwong Lee Bank, 93450 Kuching, Sarawak.',
    tel: '+60192786912',
    email: 'sarawak@bigbath.com.my',
    reg: '202201036465(1482162-W)',
  },
  'Big Bath EcoSky (Project Team)': {
    name: 'Big Bath B2B Team (ID / Project Team)',
    addr1: 'No. 16, Jalan Metro Pudu, Fraser Business Park,',
    addr2: 'Off Jalan Yew, 55200 Kuala Lumpur.',
    tel: '+60192072686',
    email: 'kepong@bigbath.com.my',
    reg: '200901005727(848677-U)',
  },
  'Leonfast (Wholesale)': {
    name: 'LEONFAST SDN. BHD.',
    addr1: 'No. 48 & 48A, Jalan Taming 2, Taman Taming Jaya,',
    addr2: '43300 Seri Kembangan, Selangor.',
    tel: '+60196699127',
    email: 'wholesale@leonfast.com.my',
    reg: '199201010984(242487-U)',
    logo: 'https://cdn.shopify.com/s/files/1/0331/3709/8797/files/Screenshot_2026-07-11_at_5.35.54_PM.png?v=1783762654',
  },
};

const DEFAULT_OUTLET_ID = 'Big Bath (Kuala Lumpur)';

const DEFAULT_OUTLET = {
  name: 'Big Bath (Kuala Lumpur)',
  addr1: 'No. 16, Jalan Metro Pudu, Fraser Business Park,',
  addr2: 'Off Jalan Yew, 55200 Kuala Lumpur.',
  tel: '+60192286912',
  email: 'kl@bigbath.com.my',
  reg: '202001009968(1366288-P)',
};

class CartQuotationGenerator {
  constructor(container) {
    this.container = container;
    this.trigger = container.querySelector('[data-cart-quotation-trigger]');
    this.statusBox = container.querySelector('[data-cart-quotation-status]');
    this.defaultLabel = this.trigger ? this.trigger.innerHTML : 'Get Quotation';
    this.endpoint = container.dataset.quotationEndpoint || '';
    this.customer = {
      first_name: container.dataset.customerFirstName || '',
      last_name: container.dataset.customerLastName || '',
      email: container.dataset.customerEmail || '',
      phone: container.dataset.customerPhone || '',
      address1: container.dataset.customerAddress1 || '',
      address2: container.dataset.customerAddress2 || '',
      city: container.dataset.customerCity || '',
      zip: container.dataset.customerZip || '',
      province: container.dataset.customerProvince || '',
      country: container.dataset.customerCountry || '',
    };
    this.shop = {
      name: container.dataset.shopName || '',
      logo_url: container.dataset.shopLogoUrl || '',
      currency: container.dataset.shopCurrency || 'MYR',
    };
    const outletKey = container.dataset.preferredOutlet || '';
    this.outlet = OUTLET_DATA[outletKey] || DEFAULT_OUTLET;
    // Stable id for analytics, so renaming an outlet doesn't split its reporting.
    this.outletId = OUTLET_DATA[outletKey] ? outletKey : DEFAULT_OUTLET_ID;
    this.isWholesale = outletKey === 'Leonfast (Wholesale)';

    // Outlets can override the default shop logo (e.g. Leonfast uses its own).
    if (this.outlet.logo) {
      this.shop.logo_url = this.outlet.logo;
    }

    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.handleClick());
    }
  }

  async handleClick() {
    if (!this.trigger) return;
    if (!this.endpoint) {
      this.renderStatus('error', 'Quotation failed', ['Quotation endpoint is not configured.']);
      return;
    }

    this.setLoading(true);
    this.renderStatus('', 'Preparing quotation', [
      'Saving this quotation and generating a PDF from your current cart...',
    ]);

    try {
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });

      const cart = await cartResponse.json().catch(() => null);
      if (!cartResponse.ok || !cart) {
        throw new Error('Could not load the latest cart data.');
      }
      if (!Array.isArray(cart.items) || cart.items.length === 0) {
        throw new Error('Your cart is empty. Add products before generating a quotation.');
      }

      const response = await fetch(this.endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(this.buildPayload(cart)),
      });

      const result = await response.json().catch(() => null);
      if (!response.ok || !result) {
        throw new Error(this.getErrorMessage(result) || 'Could not save the quotation.');
      }
      if (!result.pdf_url) {
        throw new Error('Quotation created, but the PDF URL was missing from the response.');
      }

      this.renderStatus('approved', 'Quotation ready', [
        `Quote ${result.quote_number || ''}`.trim(),
        'Your PDF has been generated and saved to your account history.',
      ], [
        { label: 'View PDF', href: result.pdf_url },
        result.whatsapp_url ? { label: 'Send via WhatsApp', href: result.whatsapp_url } : null,
      ]);
    } catch (error) {
      this.renderStatus('error', 'Quotation failed', [error.message || 'Could not generate the quotation.']);
    } finally {
      this.setLoading(false);
    }
  }

  buildPayload(cart) {
    return {
      customer: this.customer,
      outlet: this.outlet,
      shop: this.shop,
      wholesale: this.isWholesale,
      cart: {
        currency: cart.currency || this.shop.currency,
        total_price: Number(cart.total_price || 0),
        item_count: Number(cart.item_count || 0),
        items: (cart.items || []).map((item) => ({
          id: item.id || null,
          product_id: item.product_id || null,
          variant_id: item.variant_id || null,
          sku: item.sku || '',
          title: item.title || '',
          product_title: item.product_title || item.title || '',
          variant_title: item.variant_title || '',
          vendor: item.vendor || '',
          quantity: Number(item.quantity || 0),
          final_price: Number(item.final_price || 0),
          final_line_price: Number(item.final_line_price || 0),
          image: item.image || '',
          properties: item.properties || {},
        })),
      },
    };
  }

  getErrorMessage(result) {
    if (!result) return '';
    if (typeof result.detail === 'string') return result.detail;
    if (Array.isArray(result.detail)) {
      return result.detail.map((entry) => entry.msg || entry.message).filter(Boolean).join(', ');
    }
    return '';
  }

  setLoading(isLoading) {
    if (!this.trigger) return;

    this.trigger.disabled = isLoading;
    this.trigger.classList.toggle('is-loading', isLoading);
    this.trigger.innerHTML = isLoading
      ? '<span class="cart-quotation__spinner" aria-hidden="true"></span><span>Generating...</span>'
      : this.defaultLabel;
  }

  renderStatus(tone, title, lines, actions = []) {
    if (!this.statusBox) return;

    this.statusBox.hidden = false;
    this.statusBox.className = 'cart-quotation__status';
    if (tone) {
      this.statusBox.classList.add(`is-${tone}`);
    }

    const fragments = [];
    if (title) {
      fragments.push(`<strong>${this.escapeHtml(title)}</strong>`);
    }

    (lines || []).filter(Boolean).forEach((line) => {
      fragments.push(`<p>${this.escapeHtml(line)}</p>`);
    });

    const waIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true" style="flex-shrink:0;display:block;margin-right:0.5rem;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`;

    const actionLinks = (actions || [])
      .filter(Boolean)
      .map((action) => {
        const isWa = (action.href && action.href.includes('whatsapp')) || action.label.toLowerCase().includes('whatsapp');
        const extraClass = isWa ? ' cart-quotation__status-link--wa' : '';
        const icon = isWa ? waIcon : '';
        const waAttrs = isWa
          ? ` data-branch="${this.escapeAttribute(this.outletId)}" data-touchpoint="cart_quotation" onclick="window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'ctwa_click',touchpoint:'cart_quotation',branch:this.dataset.branch})"`
          : '';
        return `<a class="cart-quotation__status-link${extraClass}" href="${this.escapeAttribute(action.href)}" target="_blank" rel="noopener noreferrer"${waAttrs}>${icon}${this.escapeHtml(action.label)}</a>`;
      })
      .join('');

    if (actionLinks) {
      fragments.push(`<div class="cart-quotation__status-actions">${actionLinks}</div>`);
    }

    this.statusBox.innerHTML = fragments.join('');
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  escapeAttribute(value) {
    return this.escapeHtml(value);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-quotation]').forEach((container) => {
    new CartQuotationGenerator(container);
  });
});
